import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

export const InputManualEvaluate = styled.input`
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  color: #394d60;
  height: 40px;
  width: 120px;
  border-radius: 4px;
  border: 1px solid #e0e5eb;

  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Lato', sans-serif;
  text-align: center;

  ${({ msg }) =>
    msg &&
    css`
      &::after {
        position: absolute;
        content: '${msg}';
        top: -26px;
        left: -20px;
        width: 160px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        font-family: 'Lato', sans-serif;
        color: #121a21;
      }
    `}
  ${({ isEmpty }) =>
    isEmpty &&
    css`
      input {
        border: 1px solid red;
        border-radius: 4px;
      }
    `}
`;
export const ContainerInput = styled.div`
  width: 100px;
  position: relative;
  border: none;
  border-radius: 4px;
  width: 120px;

  ${({ msg }) =>
    msg &&
    css`
      &::after {
        position: absolute;
        content: '${msg}';
        top: -26px;
        left: -20px;
        width: 160px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        font-family: 'Lato', sans-serif;
        color: #121a21;
      }
    `}
  ${({ isEmpty }) =>
    isEmpty &&
    css`
      input {
        border: 1px solid red;
        border-radius: 4px;
      }
    `}
  input {
    color: #394d60;
    height: 34px;

    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Lato', sans-serif;
    text-align: center;
  }
`;

export const BoxNota = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  background-color: ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  position: relative;

  ${({ withError }) =>
    withError &&
    css`
      input {
        border: 1px solid #b22400 !important;
      }
    `}

  ${({ msg }) =>
    msg &&
    css`
      &::after {
        position: absolute;
        content: '${msg}';
        top: -26px;
        left: -20px;
        width: 160px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        font-family: 'Lato', sans-serif;
        color: #121a21;
      }
    `}

  input {
    flex: 1;
    color: #394d60;
    width: 120px;
    height: 37px;
    border-radius: 4px;

    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Lato', sans-serif;
    text-align: center;
  }
`;

export const BoxNotaManual = styled.div`
  position: relative;

  ${({ msg }) =>
    msg &&
    css`
      &::after {
        position: absolute;
        content: '${msg}';
        top: -26px;
        left: 0;
        width: 100px;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        font-family: 'Lato', sans-serif;
        color: #121a21;
      }
    `}
`;

export const ContainerNotas = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
`;

export const ContentHeader = styled.div`
  display: grid;
  justify-content: space-between;
  height: 35px;
  margin-top: 20px;

  ${({ hasFourColum }) =>
    hasFourColum
      ? css`
          grid-template-columns: 3fr 1fr 1fr 1fr;
          width: 60%;
        `
      : css`
          grid-template-columns: 3fr 1fr 1fr;
          width: 50%;
        `}
`;

export const ContentItem = styled.div`
  display: grid;
  justify-content: space-between;
  height: 35px;
  margin: 10px 0;

  ${({ hasFourColum }) =>
    hasFourColum
      ? css`
          grid-template-columns: 3fr 1fr 1fr 1fr;
          width: 60%;
        `
      : css`
          grid-template-columns: 3fr 1fr 1fr;
          width: 50%;
        `}
`;

export const ContentFooter = styled.div`
  display: grid;

  ${({ hasFourColum }) =>
    hasFourColum
      ? css`
          grid-template-columns: 3fr 1fr 1fr 1fr;
          width: 60%;
        `
      : css`
          grid-template-columns: 3fr 1fr 1fr;
          width: 50%;
        `}
`;
export const Item = styled.div`
  width: 120px;
  height: 40px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${BaSeTheme.colors.institucionais.cinzaSebrae45};
`;

export const BoxPendingAvaliation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
`;

export const BoxPendingAvaliationButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;

export const ContainerNotes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
`;

export const InputDisabled = styled.div`
  border: 1px solid #e0e5eb;
  height: 40px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
`;

export const ContainerResultnOTES = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 700px;
`;

export const ContentBlocs = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ContentNotes = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
`;

export const ContentRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5em 0;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  width: 700px;
`;

export const ContainerTitle = styled.div`
  height: 50px;
  border-bottom: 1px solid #8b99a7;
`;

export const ContentTitle = styled.div`
  padding: 5px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContentTabs = styled.div`
  padding: 5px 30px;
`;

export const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 4px 8px rgba(20, 46, 82, 0.2);
`;

export const ContainerDialog = styled.div`
  display: grid;
  gap: 8px;
`;
